module.exports = __webpack_public_path__ + "static/img/bg-Overview.ec00c9bb.png";